import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router-dom";
import classNames from "classnames";
import cls from "./styles.module.scss";

const MODES = [
  {
    labelKey: "app.modes.goals",
    to: "/apps/goals",
    match: (pathname: string) => pathname.startsWith("/apps/goals"),
  },
  {
    labelKey: "app.modes.raffle",
    to: "/apps/raffle",
    match: (pathname: string) => pathname.startsWith("/apps/raffle"),
  },
] as const;

type ModeTabsProps = {
  className?: string;
};

export const ModeTabs = ({ className }: ModeTabsProps) => {
  const { pathname, search } = useLocation();
  const { t } = useTranslation();
  const activeModeIndex = MODES.findIndex((mode) => mode.match(pathname));

  return (
    <div className={classNames(cls.modeTabs, className)}>
      <div
        className={cls.modeIndicator}
        style={{
          transform: `translateX(${Math.max(activeModeIndex, 0) * 100}%)`,
        }}
      />
      {MODES.map((mode) => (
        <NavLink
          key={mode.to}
          to={{
            pathname: mode.to,
            search,
          }}
          className={() =>
            [
              cls.modeTab,
              mode.match(pathname) ? cls.modeTabActive : "",
            ].join(" ")
          }
          end={mode.to === "/apps/raffle"}
        >
          {t(mode.labelKey)}
        </NavLink>
      ))}
    </div>
  );
};
